export default "__VITE_ASSET__DftW0cCS__"